define('GeneralInquiryForm.ei1.Main', [
    'Inquiry.ei1.Main.View'
], function (
    InquiryMainView
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'inquiry_page.tpl',
                routes: ['inquire'],
                view: InquiryMainView,
                defaultTemplate: {
                    name: 'inquiry_page.tpl',
                    displayName: 'General Inquiry'
                }
            });
        }
    };
});
